import type { DateTime, DateTimeFormatOptions } from 'luxon'

export default function getSessionTimespanString({
  startDate,
  endDate,
  dateFormat,
}: {
  startDate: DateTime
  endDate: DateTime
  dateFormat: 'day-of-week' | 'day-of-month'
}): string {
  const isSameDay = startDate.day === endDate.day
  const baseConfig: DateTimeFormatOptions = { hour: 'numeric', minute: '2-digit' }

  const dateFormatConfig: DateTimeFormatOptions =
    dateFormat === 'day-of-week' ? { weekday: 'short' } : { month: 'short', day: 'numeric' }

  const startTimeString = startDate.toLocaleString({
    ...baseConfig,
    ...dateFormatConfig,
  })
  const endTimeString = endDate.toLocaleString({
    ...baseConfig,
    ...(!isSameDay ? dateFormatConfig : {}),
    timeZoneName: 'short',
  })
  return `${startTimeString} - ${endTimeString}`
}
